// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var CssGrid = require("components/CssGrid");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
var DisplayNeighborhoodInputRelay = require("../DisplayNeighborhoodInputRelay.bs.js");
var PropertyWizardFormRelay__Validators__Description = require("./PropertyWizardFormRelay__Validators__Description.bs.js");
var PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql = require("../../../__generated__/PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.bs.js");
var PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql = require("../../../__generated__/PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.bs.js");

var convertFragment = PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$1, fRef);
}

var FormStateFragment_localDraftGeocodingStatus_decode = PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.Utils.localDraftGeocodingStatus_decode;

var FormStateFragment_localDraftGeocodingStatus_fromString = PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.Utils.localDraftGeocodingStatus_fromString;

var FormStateFragment = {
  localDraftGeocodingStatus_decode: FormStateFragment_localDraftGeocodingStatus_decode,
  localDraftGeocodingStatus_fromString: FormStateFragment_localDraftGeocodingStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__Description__DisplayNeighborhood(props) {
  var match = PropertyWizardFormRelay.Context.use();
  var draft = use(props.draft);
  var formState = use$1(props.formState);
  var displayNeighborhoodIsValid = PropertyWizardFormRelay__Validators__Description.DisplayNeighborhood.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  var displayNeighborhood = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "DraftProperty",
        _0: (function (dp, value) {
            var newrecord = Caml_obj.obj_dup(dp);
            newrecord.displayNeighborhood = value !== undefined ? ({
                  id: value.id,
                  label: value.label
                }) : undefined;
            return newrecord;
          })
      }, props.stepHasBeenTouched, draft.draftProperty.displayNeighborhood, displayNeighborhoodIsValid);
  var match$1 = formState.displayNeighborhoods;
  var match$2 = draft.draftProperty.displayNeighborhood;
  var areas;
  var exit = 0;
  if (match$1.length !== 0 || match$2 === undefined) {
    exit = 1;
  } else {
    areas = [{
        id: match$2.id,
        name: match$2.label
      }];
  }
  if (exit === 1) {
    areas = formState.displayNeighborhoods.map(function (dn) {
          return {
                  id: dn.id,
                  name: dn.label
                };
        });
  }
  var helpText;
  var tmp = match.mode;
  helpText = typeof tmp !== "object" || tmp.TAG !== "Rebroadcast" ? "Select what neighborhood you would like to display on your broadcast.\nCan't find your preferred neighborhood? Just leave it blank. This won't have an impact on matching." : "You can edit the display neighborhood if you wish. This is for display only and has no impact on matching.";
  var match$3 = displayNeighborhood.value;
  var match$4 = formState.geocodingStatus;
  var tmp$1;
  if (match$3 !== undefined) {
    tmp$1 = undefined;
  } else {
    switch (match$4) {
      case "NotCalled" :
          tmp$1 = "Missing address. Please check Key Facts...";
          break;
      case "Called" :
          tmp$1 = "Loading display neighborhoods...";
          break;
      case "Valid" :
          tmp$1 = undefined;
          break;
      default:
        tmp$1 = "Error validating the address. Please check Key Facts...";
    }
  }
  var match$5 = displayNeighborhood.value;
  var match$6 = formState.geocodingStatus;
  var tmp$2;
  tmp$2 = match$5 !== undefined || match$6 === "Valid" ? false : true;
  var match$7 = displayNeighborhood.valid;
  var match$8 = displayNeighborhood.value;
  return JsxRuntime.jsxs(CssGrid.Cell, {
              width: 12,
              children: [
                JsxRuntime.jsx(DisplayNeighborhoodInputRelay.make, {
                      areas: areas,
                      placeholder: tmp$1,
                      helpText: helpText,
                      isDisabled: tmp$2,
                      onChange: (function (value) {
                          displayNeighborhood.onChange(value !== undefined ? ({
                                    id: value.id,
                                    label: value.name
                                  }) : undefined);
                        }),
                      status: match$7 !== undefined ? (
                          typeof match$7 === "object" ? "error" : "ok"
                        ) : undefined,
                      value: match$8 !== undefined ? ({
                            id: match$8.id,
                            name: match$8.label
                          }) : undefined
                    }),
                JsxRuntime.jsx(Form__Components.FieldError.make, {
                      valid: displayNeighborhood.valid
                    })
              ]
            });
}

var Components;

var TextInputField;

var Cell;

var Grid;

var Validators;

var FormUtils;

var make = PropertyWizardRelay__Description__DisplayNeighborhood;

exports.Components = Components;
exports.TextInputField = TextInputField;
exports.Cell = Cell;
exports.Grid = Grid;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.make = make;
/* Form__Components Not a pure module */
